import { useMediaQuery, useTheme } from '@chakra-ui/react';
import { memoizedGet as get } from '@chakra-ui/utils';
import { breakpoints } from '../theme/foundations/breakpoints';
export const useIsMobile = (opts) => {
    const theme = useTheme();
    const mdBreakpoint = get(theme, 'breakpoints.md', breakpoints.md);
    const [isLargerThanMd] = useMediaQuery(`(min-width: ${mdBreakpoint})`, opts);
    return !isLargerThanMd;
};
